import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";

export default function ProductManager() {
  return (
    <div>
      <div
        style={{
          boxShadow:"  0 3px 10px rgb(0 0 0 / 0.2);",
        }}
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <span style={{ marginLeft: 26, fontWeight: "bold", fontSize: 18 }}>
          {" "}
          ຈັດການສີນຄ້າ
        </span>
      </div>
    </div>
  );
}
